import {
  Loading,
  MAutocomplete,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import { useInstallation } from "@services/servicesGenericsTables";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";

const PuntosMuestreoForm = () => {
  const { getValues } = useFormContext();
  const { installationList } = useInstallation();

  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MAutocomplete
          key={JSON.stringify(getValues("instalacion"))}
          name="instalacion"
          options={installationList}
          label="Instalación"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}`
          }
          validation={{ required: "La instalación es requerida" }}
        />
        <MTextField
          key={"codigo"}
          name={"codigo"}
          label={"Codigo"}
          type="text"
          fullWidth
          validation={{ required: `El campo codigo es requerido` }}
        />
        <MTextField
          key={"descripcion"}
          name={"descripcion"}
          label={"Descripcion"}
          type="text"
          fullWidth
          validation={{ required: `El campo descripcion es requerido` }}
        />
        <MTextField
          key={"distancia"}
          name={"distancia"}
          label={"Distancia"}
          type="text"
          fullWidth
          validation={{ required: `El campo distancia es requerido` }}
        />
        <MTextField
          key={"sector"}
          name={"sector"}
          label={"Sector"}
          type="text"
          fullWidth
          validation={{ required: `El campo sector es requerido` }}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default PuntosMuestreoForm;
